import React from "react";
import { apiGet } from "../api";

export const AffiliatorMyInfoContext = React.createContext();

const UnnamedComponent = (props) => {
  const [myInfo, setMyInfo] = React.useState({});
  const reloadMyInfo = React.useCallback(async () => {
    const { parsedResponse, statusCode } = await apiGet(
      "/api/v1/users/affiliators/info",
    );
    if (statusCode === 200) {
      setMyInfo(parsedResponse.data);
    }
  }, []);
  React.useEffect(() => {
    reloadMyInfo();
  }, []);

  const contextValue = React.useMemo(
    () => ({ myInfo, setMyInfo, reloadMyInfo }),
    [myInfo, setMyInfo, reloadMyInfo],
  );
  return (
    <AffiliatorMyInfoContext value={contextValue}>
      {props.children}
    </AffiliatorMyInfoContext>
  );
};

export default UnnamedComponent;
